import {Component, DestroyRef, inject, OnInit, signal, linkedSignal} from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';
import {AdminBadgeResponse, Client} from "@/api/client";
import {Badge} from "primeng/badge";
import {interval} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {AuthService} from "@/pages/service/auth.service";

interface Menu {
    label: string;
    items: MenuItem[];
}

interface MenuItem {
    label: string;
    icon?: string;
    routerLink?: string[];
    class?: string;
    badge?: string;
}
@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, RouterModule, Badge],
    templateUrl: './app.menu.html',
})
export class AppMenu implements OnInit {
    client = inject(Client)
    destroyRef = inject(DestroyRef)
    auth = inject(AuthService);
    bages = signal<AdminBadgeResponse | null>(null)

    model = linkedSignal<AdminBadgeResponse | null, Menu[]>({
        source: () => this.bages(),
        computation: (bages) => [
            {
                label: 'Панель управления',
                items: [
                    { label: 'Настройки', icon: 'pi pi-fw pi-cog', routerLink: ['/settings'] },
                    { label: 'Слайдер', icon: 'pi pi-fw pi-image', routerLink: ['/slider'] },
                    { label: 'Коды телефонов', icon: 'pi pi-fw pi-phone', routerLink: ['/phones-code'] }
                ]
            },
            {
                label: 'Пользователи',
                items: [
                    { label: 'Пользователи', icon: 'pi pi-fw pi-user', class: 'rotated-icon', routerLink: ['/users'] },
                    { label: 'Сектора', icon: 'pi pi-fw pi-map', routerLink: ['/sectors'] },
                    { label: 'Маршруты', icon: 'pi pi-fw pi-truck', routerLink: ['/routes'] },
                    { label: 'Уровни цен', icon: 'pi pi-fw pi-chart-line', routerLink: ['/price-levels'] },
                    { label: 'Переписка', icon: 'pi pi-fw pi-comment', routerLink: ['/chat'], badge: bages?.mailing?.toString() },
                    { label: 'Обратная связь', icon: 'pi pi-fw pi-users', routerLink: ['/feed-back'], badge: bages?.contactUs?.toString() },
                    { label: 'Запись на СТО', icon: 'pi pi-fw pi-wrench', routerLink: ['/sto-record'], badge: bages?.sto?.toString() },
                ]
            },
            {
                label: 'Товарный раздел',
                items: [
                    { label: 'Заказы', icon: 'pi pi-fw pi-cart-minus', class: 'rotated-icon', routerLink: ['/order'], badge: bages?.order?.toString() },
                    { label: 'Товары', icon: 'pi pi-fw pi-box', class: 'rotated-icon', routerLink: ['/products'] },
                    { label: 'Категории', icon: 'pi pi-fw pi-list', routerLink: ['/categories'] },
                    { label: 'Конструктор категорий', icon: 'pi pi-fw pi-objects-column', routerLink: ['/category-constructor'] },
                    { label: 'Единицы измерения', icon: 'pi pi-fw pi-chart-scatter', routerLink: ['/measure-units'] },
                    { label: 'Опции', icon: 'pi pi-fw pi-list-check', routerLink: ['/options'] },
                    { label: 'Бренды', icon: 'pi pi-fw pi-tags', routerLink: ['/brands'] },
                ]
            },
            {
                label: 'Наполнения Сайта',
                items: [
                    { label: 'Новости и акции', icon: 'pi pi-fw pi-mobile', class: 'rotated-icon', routerLink: ['/news'] },
                    { label: 'Вопросы и ответы', icon: 'pi pi-question', class: 'rotated-icon', routerLink: ['/faq'] },
                    { label: 'Site Map', icon: 'pi pi-replay', class: 'rotated-icon', routerLink: ['/site-map'] },
                    { label: 'История поиска', icon: 'pi pi-file-excel', routerLink: ['/logging-search'] },
                    { label: 'Хранилище', icon: 'pi pi-folder-plus', class: 'rotated-icon', routerLink: ['/data-storage'] },
                    { label: 'Локации', icon: 'pi pi-fw pi-map-marker', class: 'rotated-icon', routerLink: ['/location'] },
                    { label: 'Контактная информация', icon: 'pi pi-fw pi-warehouse', routerLink: ['/storage'] },
                    { label: 'SEO', icon: 'pi pi-fw pi-compass', class: 'rotated-icon', routerLink: ['/seo'] },
                    { label: 'Популярные категории', icon: 'pi pi-fw pi-star', class: 'rotated-icon', routerLink: ['/popular-category-constructor'] },
                    { label: 'Каталог', icon: 'pi pi-fw pi-sitemap', class: 'rotated-icon', routerLink: ['/catalogs-constructor'] },
                    { label: 'Страны', icon: 'pi pi-fw pi-globe', routerLink: ['/countries'] },
                    { label: 'Города', icon: 'pi pi-fw pi-building', routerLink: ['/cities'] },
                    { label: 'Категории для скачивания', icon: 'pi pi-fw pi-book', routerLink: ['/download-category'] },
                    { label: 'Файлы для скачивания', icon: 'pi pi-fw pi-save', routerLink: ['/download-file'] },
                    { label: 'Поставщики', icon: 'pi pi-fw pi-shop', routerLink: ['/partners'] },
                    { label: 'Страницы', icon: 'pi pi-fw pi-tablet', routerLink: ['/pages'] },
                ]
            },
            {
                label: 'TecDoc',
                items: [
                    { label: 'Марки авто', icon: 'pi pi-fw pi-car', class: 'rotated-icon', routerLink: ['/car-brand'] },
                    { label: 'Модели авто', icon: 'pi pi-fw pi-microchip', routerLink: ['/car-model'] },
                    { label: 'Модификации авто', icon: 'pi pi-fw pi-gauge', routerLink: ['/car-modification'] },
                    { label: 'Бренды: Черный список', icon: 'pi pi-fw pi-thumbs-down-fill', routerLink: ['/black-list'] },
                ]
            },
        ]
    });

    getLabels() {
        this.client.adminSetting_BadgeCount().subscribe({
            next: (data) => {
                this.bages.set(data)
            }
        })
    }

    ngOnInit() {
        if (this.auth.isAuth()) {
            this.getLabels()
            interval(60000)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(() => this.getLabels());
        }
    }
}
